// Octane AI quiz results. Octane fires octane.quiz.addToCart with { items: [{ id, quantity, … }] } (the /cart/add.js
// shape) when the shopper adds their recommendations, and octane.quiz.viewCart for "View cart". Adds go through
// Shopify's standard cart event so the header count updates and the cart drawer opens, as it did before.
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.purolabsOctaneQuiz) {
  window.purolabsOctaneQuiz = true;
  const root = () => window.Shopify?.routes?.root || '/';

  document.addEventListener('octane.quiz.addToCart', async (event) => {
    const items = event.detail?.items;
    if (!items?.length) return;
    const deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: Number(item.quantity) || 1 })),
        promise: deferred.promise,
      })
    );
    try {
      const response = await fetch(`${root()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) throw new Error((await response.json()).description);
      const cart = await fetch(`${root()}cart.js`).then((r) => r.json());
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { source: 'pl-octane-quiz', items: cart.items } });
    } catch (error) {
      console.error('Octane quiz add to cart:', error);
      // Resolved with didError (as the rest of the cart code does) so the drawer opens with the message
      deferred.resolve({ cart: null, detail: { didError: true, error: error.message || 'Sorry, that couldn’t be added.', source: 'pl-octane-quiz' } });
    }
  });

  document.addEventListener('octane.quiz.viewCart', () => document.dispatchEvent(new CustomEvent('purolabs:cart:open')));
}
